import { Routes } from '@angular/router';
import { AuthGuard } from './services/guard/auth.guard';
import { MaintenanceGuard } from './services/guard/maintenance.guard';
import { VersionGuard } from './services/guard/version.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'public',
    pathMatch: 'full'
  },
  {
    path: 'public',
    loadComponent: () => import('./pages/public/navigation/navigation.page').then(m => m.PublicNavigationPage),
    canActivate: [MaintenanceGuard, VersionGuard],
    canActivateChild: [MaintenanceGuard, VersionGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/public/home/home.page').then(m => m.PublicHomePage)
      },
      {
        path: 'about',
        loadComponent: () => import('./pages/public/content/about/about.page').then(m => m.PublicAboutPage)
      },
      {
        path: 'content/register',
        loadComponent: () => import('./pages/public/content/register/register.page').then(m => m.PublicInfoRegisterPage)
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/public/settings/settings.page').then(m => m.PublicSettingsPage)
      },
      {
        path: 'maintenance',
        loadComponent: () => import('./pages/public/content/maintenance/maintenance.page').then(m => m.PublicMaintenancePage)
      },
      {
        path: 'account/login',
        loadComponent: () => import('./pages/public/account/login/login.page').then(m => m.PublicLoginPage)
      },
      {
        path: 'account/email-sent',
        loadComponent: () => import('./pages/public/account/email-sent/email-sent.page').then(m => m.PublicEmailSentPage)
      },
      {
        path: 'account/register',
        loadComponent: () => import('./pages/public/account/register/register.page').then(m => m.PublicRegisterPage)
      },
      {
        path: 'account/phone-verify',
        loadComponent: () => import('./pages/public/account/phone-verify/phone-verify.page').then(m => m.PublicPhoneVerifyPage)
      },
      {
        path: 'account/forgot',
        loadComponent: () => import('./pages/public/account/forgot/forgot.page').then(m => m.PublicForgotPage)
      },
      {
        path: 'account/profile',
        loadComponent: () => import('./pages/public/account/profile/profile.page').then(m => m.PublicProfilePage)
      },
      {
        path: 'account/agreements',
        loadComponent: () => import('./pages/public/account/terms/terms.page').then(m => m.PublicTermsPage)
      },
      {
        path: 'account/terms',
        redirectTo: 'account/agreements',
        pathMatch: 'full'
      },
      {
        path: 'account/privacy',
        redirectTo: 'account/agreements',
        pathMatch: 'full'
      },
      {
        path: 'account/provision',
        redirectTo: 'account/agreements',
        pathMatch: 'full'
      },
      {
        path: 'account/version',
        loadComponent: () => import('./pages/public/account/version/version.page').then(m => m.PublicVersionPage)
      },
      {
        path: 'account/help',
        loadComponent: () => import('./pages/public/account/help/help.page').then(m => m.PublicHelpPage)
      },
      {
        path: 'account/banned',
        loadComponent: () => import('./pages/public/account/banned/banned.page').then(m => m.PublicBannedPage)
      },
      {
        path: 'account/inactive',
        loadComponent: () => import('./pages/public/account/inactive/inactive.page').then(m => m.PublicInactivePage)
      },
      {
        path: 'account/waiting',
        loadComponent: () => import('./pages/public/account/waiting/waiting.page').then(m => m.PublicWaitingPage)
      }
    ]
  },
  {
    path: 'client',
    loadChildren: () => import('./pages/client/client-routing').then(m => m.routes),
    canActivate: [AuthGuard, VersionGuard]
  },
  {
    path: 'worker',
    loadChildren: () => import('./pages/worker/worker-routing').then(m => m.routes),
    canActivate: [AuthGuard, VersionGuard]
  }
];
